<div class="radio-button-list" [ngClass]="isHorizontalAlignment ? 'horizontal-alignment' : 'vertical-alignment'">
  <ng-content />
</div>
